module.exports = __webpack_public_path__ + "static/img/noCart1.49e0be5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noCart1.png
// module id = 839
// module chunks = 0